module.exports = "/images/vendor/flag-icon-css/flags/1x1/fm.svg?3f19d612c1d987a0948edbf753d9b96f";